import React from 'react';
import styled from '@emotion/styled';
import {
    color_shades_darkest,
    voicify_spark_light
} from '../../../../../shared/constants/colors';
import TooltipWrapper from '../../../../../shared/components/general/TooltipWrapper';
import { OUTBOUND_APPOINTMENT_RESPONSE_RATE_HEALTHCARE_DEFINITION } from '../../../../../shared/constants/analyticsConstants/metricsDefinitions';

interface AppointmentSummaryMetricButtonProps {
    onClick: () => void;
    disabled?: boolean;
    tooltipDescription?: string;
    help?: React.ReactNode;
}

const AppointmentSummaryMetricButton: React.FC<AppointmentSummaryMetricButtonProps> = ({
    onClick,
    disabled = false,
    tooltipDescription,
    help,
    children
}) => {
    const definition = OUTBOUND_APPOINTMENT_RESPONSE_RATE_HEALTHCARE_DEFINITION;
    const description = tooltipDescription || `${definition.name}. ${definition.description} How it's calculated: ${definition.calculation} Note: ${definition.notes}`;
    return (
        <MetricWrapper>
            {disabled ? <div>{children}</div> : (
                <TooltipWrapper
                    text={<><strong>Click to view breakdown</strong><br />{description}</>}
                    accessibleDescription={`Click to view breakdown. ${description}`}
                    trigger={['hover', 'focus']}
                    place="top"
                    maxWidth={280}
                >
                    <MetricButton
                        type="button"
                        onClick={onClick}
                        aria-label="View outbound appointment success details"
                    >
                        {children}
                    </MetricButton>
                </TooltipWrapper>
            )}
            {help && <MetricHelp>{help}</MetricHelp>}
        </MetricWrapper>
    );
};

const MetricWrapper = styled.div`
    position: relative;
`;

const MetricHelp = styled.span`
    position: absolute;
    right: 0;
    bottom: 0;
`;

const MetricButton = styled.button`
    display: block;
    position: relative;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: ${color_shades_darkest};
    cursor: pointer;
    font: inherit;
    text-align: right;

    transition: opacity 160ms ease;

    &:hover {
        opacity: 0.8;
    }

    &:focus-visible {
        outline: 3px solid ${voicify_spark_light};
        outline-offset: 4px;
        border-radius: 4px;
    }
`;

export default AppointmentSummaryMetricButton;
